import React from 'react';
import { Button, Link } from 'components';

const Message = ({ to, size = 'xsmall', fit = false }) => {
  return (
    <Link to={to}>
      <Button
        xsmall={size === 'xsmall'}
        small={size === 'small'}
        fit={fit}
        onClick={() => null}
        outlined={true}
      >
        <span style={{ display: 'inline-block', paddingTop: '2px' }}>
          Message
        </span>
      </Button>
    </Link>
  );
};

export default Message;
